import TableCell from "@mui/material/TableCell";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

interface Props {
  title: string;
  content?: string | number;
  image?: string;
  noBorder?: boolean;
  maxWidth?: string; // Optional prop to specify the maxWidth
  [key: string]: any;
}

function StatusTableCell({
  title,
  content,
  image,
  noBorder,
  maxWidth,
  ...rest
}: Props): JSX.Element {
  let template;

  const imageTextContainerStyle = {
    display: "flex",
    alignItems: "center",
    width: "max-content",
    maxWidth: maxWidth || "200px",
    flexDirection: "row" as "row" | "column",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  if (image) {
    template = (
      <TableCell {...rest} align="left" sx={{ border: noBorder && 0 }}>
        <MDBox style={imageTextContainerStyle}>
          {image}{" "}
          <MDBox display="flex" flexDirection="column" ml={3}>
            <MDTypography
              variant="caption"
              color="text"
              fontWeight="medium"
              textTransform="capitalize"
            >
              {title}:
            </MDTypography>
            <MDTypography variant="button" fontWeight="regular" textTransform="capitalize">
              {content}
            </MDTypography>
          </MDBox>
        </MDBox>
      </TableCell>
    );
  } else {
    template = (
      <TableCell {...rest} align="center" sx={{ border: noBorder && 0 }}>
        <MDBox display="flex" flexDirection="column">
          <MDTypography
            variant="caption"
            color="text"
            fontWeight="medium"
            textTransform="capitalize"
          >
            {title}:
          </MDTypography>
          <MDTypography variant="button" fontWeight="regular" textTransform="capitalize">
            {content}
          </MDTypography>
        </MDBox>
      </TableCell>
    );
  }

  return template;
}

StatusTableCell.defaultProps = {
  image: "",
  noBorder: false,
  maxWidth: "200px",
};

export default StatusTableCell;
